import { makeAutoObservable } from "mobx";
import { UsersContext } from "../../typings/context";
import { AssistantProfileInfo } from "../../../api/typings/Profiles";

export class ProfileAssistantService {
  constructor(private ctx: UsersContext) {
    this.ctx = ctx;
    makeAutoObservable(this);
  }

  updateProfile = (data: AssistantProfileInfo) => {};
}
